import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { changePassword } from './api';
import { toast } from 'react-toastify';
interface Props {
    showChangePassword: boolean;
    setShowChangePassword: React.Dispatch<React.SetStateAction<boolean>>;
}
const ChangePasswordDialog = (props: Props) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleOpen = () => {
    props.setShowChangePassword(true);
  };

  const handleClose = () => {
    props.setShowChangePassword(false);
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const handleSubmit = () => {
    changePassword(oldPassword, newPassword, confirmPassword).then((response) => {
        if(response.error) toast.error(<div dangerouslySetInnerHTML={{ __html:         Object.values(response.error).map((error: any) => error.join("<br/>")).join("<br/>")}}/>);
        if(response.message) {
            toast.success(response.message);
            handleClose();
        }
    })
  };

  return (
    <div>
      <Button variant="outlined" onClick={handleOpen}>
        Cambia Password
      </Button>
      <Dialog open={props.showChangePassword} onClose={handleClose}>
        <DialogTitle>Cambia Password</DialogTitle>
        <DialogContent>
          <TextField
            label="Vecchia Password"
            type="password"
            fullWidth
            margin="dense"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
          <TextField
            label="Nuova Password"
            type="password"
            fullWidth
            margin="dense"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            label="Conferma Nuova Password"
            type="password"
            fullWidth
            margin="dense"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Annulla
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ChangePasswordDialog;
